import React, { useState } from 'react';
import { AutoCompleteComponent } from "../../../../../Shared/components/AutoCompleteComponent";
import { Button, FormControl, RadioGroup, Radio, Switch, Box, Typography, TextField, TableContainer, Table, TableHead, TableRow, TableCell, FormControlLabel } from "@mui/material";
import { SelectedIcon, UnSelectedIcon } from "../../../../../Shared/components/Icons/selectedIcon";
import { Space, Row, Col, Image } from "antd";
import { NavLink } from "react-router-dom";
import { checkQuoteProductView, storageSetItem } from "../../../../../../helpers/utilities";
import DeleteIcon from "../../../../../../assets/images/icon_actions/Delete Icon.svg";
import moment from 'moment';


export const LineForm = (props) => {
    const { classes, clsx, myProductdetails, lineForm, lineError, locationDetails, currencyFormat,
        handleProductChange, handleEdit, productApi, batch, changeHandlerBatch, onDeletBatch, receivedView,
        idNamingConversion, handleLineSubmit, view, title, handleAddMore, headerView, parameterDetails, status,
        customObject, changeHandler } = props;


    const [showNameDesc, setShowNameDesc] = useState(checkQuoteProductView());
    return (
        <Box
            className={clsx(classes.customForm, classes.removeUnderline)}
            component="form"
            autoComplete='off'
            onSubmit={(e) => handleLineSubmit(e)}>
            <div className={classes.customFormFlex}>
                <Row gutter={30}>
                    <Col style={{ position: "relative" }} xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                        <Typography variant={'h6'} className={clsx(classes.typographyHeader, classes.bold)}>Line {lineForm?.lineNumber} Details</Typography>
                        <FormControl
                            style={{ position: "absolute", right: 10, top: 0, alignItems: "end" }}
                            className={clsx(classes.dropDownPointer, classes.customRadioButton, classes.PadLR15)}
                            variant={'standard'}
                            fullWidth>
                            <RadioGroup
                                row
                                value={showNameDesc}
                                onChange={(e) => {
                                    storageSetItem('quoteProductView', e.target.value);
                                    setShowNameDesc(e.target.value);
                                }}>
                                <FormControlLabel value="name" control={<Radio
                                    checkedIcon={<UnSelectedIcon />}
                                    icon={<SelectedIcon />}
                                />} label="Name" />
                                <FormControlLabel value="description" control={<Radio
                                    checkedIcon={<UnSelectedIcon />}
                                    icon={<SelectedIcon />}
                                />} label="Description" />
                            </RadioGroup>
                        </FormControl>
                    </Col>
                    <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                        {
                            view ? <>
                                <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.margin20t, classes.fonSize13)}>Product</Typography>
                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{lineForm?.product?.productName || ''}</Typography>
                            </> : <AutoCompleteComponent
                                name={["Product ", <span key={"Product"} className={classes.colorRedRequired}> *</span>]}
                                heads={[{ 'key': showNameDesc === 'name' ? 'productName' : 'description', 'name': 'Product Name' },
                                { 'key': 'productId', 'name': 'Product ID' }, { 'key': 'universalProduct', 'name': 'UPI Id', 'relation': 'productId' }]}
                                details={myProductdetails}
                                id={idNamingConversion('Product', 'stockTransferLine', 'DropDown')}
                                parentValue={customObject(myProductdetails, lineForm?.productId)}
                                onChange={(data) => handleProductChange(data)}
                                position={"bottom"}
                                searchType={(s) => productApi(s)}
                                customClasses={classes.margin10t}
                                parentError={lineError?.productId}
                            />
                        }
                    </Col>

                    <Col xxl={8} xl={8} lg={8} md={8} sm={24} xs={24}>
                        <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.margin20t, classes.fonSize13)}>Unit</Typography>
                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>
                            {lineForm?.unit?.name || '---'}
                        </Typography>
                        {/* {
                            view || lineForm?.bulk ? <>
                                <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.margin20t, classes.fonSize13)}>Unit</Typography>
                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>
                                    {lineForm?.unit?.name || '---'}
                                </Typography>
                            </> : <AutoCompleteComponent
                                name={["Unit ", <span key={"Unit"} className={classes.colorRedRequired}> *</span>]}
                                heads={[{ 'key': 'name', 'name': 'Unit' },
                                { 'key': 'description', 'name': 'Description' }]}
                                details={parameterDetails?.inventoryTransaction ? units[lineForm.productId] : unitMesurementdetails}
                                id={idNamingConversion('Unit', 'stockTransferLine', 'DropDown')}
                                parentValue={customObject(parameterDetails?.inventoryTransaction ? units[lineForm.productId] : unitMesurementdetails, lineForm?.unitId)}
                                onChange={(data) => changeHandler(data, 'unitId')}
                                position={"bottom"}
                                customClasses={classes.margin20t}
                                parentError={lineError?.unitId}
                            />
                        } */}
                    </Col>
                    <Col xxl={8} xl={8} lg={8} md={8} sm={24} xs={24}>
                        <div className={classes.customUnitPrice}>
                            <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.margin20t, classes.fonSize13)}>Cost Price</Typography>
                            <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>
                                {lineForm?.pricePerUnit || '---'}
                            </Typography>
                        </div>
                    </Col>
                    <Col xxl={8} xl={8} lg={8} md={8} sm={24} xs={24}>
                        <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Total Cost Price</Typography>
                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{lineForm?.amount ? '₹ ' + currencyFormat(lineForm?.amount) : '---'}</Typography>
                    </Col>
                    <Col xxl={8} xl={8} lg={8} md={8} sm={24} xs={24}>
                        <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Current Stock</Typography>
                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{lineForm?.quantity || 0}</Typography>
                    </Col>
                    <Col xxl={8} xl={8} lg={8} md={8} sm={24} xs={24}>
                        {
                            view ? <>
                                <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.margin20t, classes.fonSize13)}>Shipped Quantity</Typography>
                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>
                                    {lineForm?.toQuantity || '---'}
                                </Typography>
                            </> : <TextField autoComplete='one-time-code'
                                className={clsx(classes.margin20t, classes.removeUnderline)}
                                label={["Shipped Quantity ", <span key={"Shipped Quantity"} className={classes.colorRedRequired}> *</span>]}
                                type={'number'}
                                variant={'standard'}
                                value={lineForm?.toQuantity || ''}
                                id={idNamingConversion('Shipped Quantity', 'stockTransferLine', 'TextField')}
                                error={lineError?.toQuantity}
                                helperText={lineError?.toQuantity}
                                fullWidth
                                InputProps={{
                                    classes: {
                                        input: classes.textFieldColor,
                                    }
                                }}
                                inputProps={{
                                    step: "any",
                                    //  max: (lineForm?.quantity || 0)
                                }}
                                onWheel={(e) => e.target.blur()}
                                InputLabelProps={{
                                    className: classes.textFieldLableColorCustom,
                                }}
                                onChange={(e) => {
                                    if (e.target.value !== '') {
                                        if (e.target.value < 0) {
                                            changeHandler(e.target.value = 0, 'toQuantity')
                                        } else if (!parameterDetails?.transferNegativeStock && parseFloat(e.target.value) > parseFloat(lineForm?.quantity || 0)) {
                                            changeHandler(e.target.value = (lineForm?.quantity || ''), 'toQuantity')
                                        } else {
                                            changeHandler(e.target.value, 'toQuantity')
                                        }
                                    } else {
                                        changeHandler(e.target.value, 'toQuantity')
                                    }
                                }}
                            />
                        }
                    </Col>
                    <Col xxl={8} xl={8} lg={8} md={8} sm={24} xs={24}>
                        {
                            view ? <>
                                {
                                    receivedView ? <>
                                        <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.margin20t, classes.fonSize13)}>Received Quantity</Typography>
                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>
                                            {lineForm?.receivedQuantity || '---'}
                                        </Typography>
                                    </> : <TextField autoComplete='one-time-code'
                                        className={clsx(classes.margin20t, classes.removeUnderline)}
                                        label={["Received Quantity ", <span key={"Received Quantity"} className={classes.colorRedRequired}> *</span>]}
                                        type={'number'}
                                        variant={'standard'}
                                        value={lineForm?.receivedQuantity || ''}
                                        id={idNamingConversion('Received Quantity', 'stockTransferLine', 'TextField')}
                                        error={lineError?.receivedQuantity}
                                        helperText={lineError?.receivedQuantity}
                                        fullWidth
                                        InputProps={{
                                            classes: {
                                                input: classes.textFieldColor,
                                            }
                                        }}
                                        disabled={status === 'CREATED' ? true : false}
                                        inputProps={{
                                            step: "any",
                                            max: (lineForm?.balanceQuantity || 0)
                                        }}
                                        onWheel={(e) => e.target.blur()}
                                        InputLabelProps={{
                                            className: classes.textFieldLableColorCustom,
                                        }}
                                        onChange={(e) => {
                                            if (e.target.value !== '') {
                                                if (e.target.value < 0) {
                                                    changeHandler(e.target.value = 0, 'receivedQuantity')
                                                } else if (parseFloat(e.target.value) > parseFloat(lineForm?.balanceQuantity || 0)) {
                                                    changeHandler(e.target.value = (lineForm?.balanceQuantity || ''), 'receivedQuantity')
                                                } else {
                                                    changeHandler(e.target.value, 'receivedQuantity')
                                                }
                                            } else {
                                                changeHandler(e.target.value, 'receivedQuantity')
                                            }
                                        }}
                                    />
                                }
                            </> : <TextField autoComplete='one-time-code'
                                className={clsx(classes.margin20t, classes.removeUnderline)}
                                label={["Received Quantity ", <span key={"Received Quantity"} className={classes.colorRedRequired}> *</span>]}
                                type={'number'}
                                variant={'standard'}
                                value={lineForm?.receivedQuantity || ''}
                                id={idNamingConversion('Received Quantity', 'stockTransferLine', 'TextField')}
                                error={lineError?.receivedQuantity}
                                helperText={lineError?.receivedQuantity}
                                fullWidth
                                InputProps={{
                                    classes: {
                                        input: classes.textFieldColor,
                                    }
                                }}
                                disabled={status === 'CREATED' ? true : false}
                                inputProps={{
                                    step: "any",
                                    max: (lineForm?.balanceQuantity || 0)
                                }}
                                onWheel={(e) => e.target.blur()}
                                InputLabelProps={{
                                    className: classes.textFieldLableColorCustom,
                                }}
                                onChange={(e) => {
                                    if (e.target.value !== '') {
                                        if (e.target.value < 1) {
                                            changeHandler(e.target.value = 1, 'receivedQuantity')
                                        } else if (e.target.value > (lineForm?.balanceQuantity || 0)) {
                                            changeHandler(e.target.value = (lineForm?.balanceQuantity || ''), 'receivedQuantity')
                                        } else {
                                            changeHandler(e.target.value, 'receivedQuantity')
                                        }
                                    } else {
                                        changeHandler(e.target.value, 'receivedQuantity')
                                    }
                                }}
                            />
                        }
                    </Col>
                    <Col xxl={8} xl={8} lg={8} md={8} sm={24} xs={24}>
                        {
                            view ? <>
                                <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.margin20t, classes.fonSize13)}>Location</Typography>
                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>
                                    {lineForm?.location?.name || '---'}
                                </Typography>
                            </> : <AutoCompleteComponent
                                name={["Location ", <span key={"Location"} className={classes.colorRedRequired}> *</span>]}
                                heads={[{ 'key': 'name', 'name': 'Location' }]}
                                details={locationDetails}
                                id={idNamingConversion('Location', 'stockTransferLine', 'DropDown')}
                                parentValue={customObject(locationDetails, lineForm?.locationId)}
                                onChange={(data) => changeHandler(data, 'locationId')}
                                position={"bottom"}
                                disabled={!lineForm?.productId}
                                customClasses={classes.margin20t}
                                parentError={lineError?.locationId}
                            />
                        }
                    </Col>
                    <Col xxl={8} xl={8} lg={8} md={8} sm={24} xs={24}>
                        {
                            view ? <>
                                <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.margin20t, classes.fonSize13)}>To Location</Typography>
                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>
                                    {lineForm?.toLocation?.name || '---'}
                                </Typography>
                            </> : <AutoCompleteComponent
                                name={["To Location ", <span key={"To Location"} className={classes.colorRedRequired}> *</span>]}
                                heads={[{ 'key': 'name', 'name': 'Location' }]}
                                details={locationDetails}
                                id={idNamingConversion('Location', 'stockTransferLine', 'DropDown')}
                                parentValue={customObject(locationDetails, lineForm?.toLocationId)}
                                onChange={(data) => changeHandler(data, 'toLocationId')}
                                position={"bottom"}
                                disabled={!lineForm?.productId}
                                customClasses={classes.margin20t}
                                parentError={lineError?.toLocationId}
                            />
                        }
                    </Col>
                    {
                        lineForm?.product?.batchActivation ? <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                            <Row align="middle" className={clsx(classes.margin20t)}>
                                <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                                    <Typography variant={'h6'} className={clsx(classes.typographyHeader, classes.bold)}>Batch Details</Typography>
                                </Col>
                                <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                                    <Row>
                                        <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                                            <FormControlLabel
                                                classes={{
                                                    label: clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13), // Pass your override css here
                                                }}
                                                control={<Switch size='small'
                                                    className={clsx(classes.customSwitch)}
                                                    onChange={(e) => { changeHandler(!lineForm?.batchOverride, 'batchOverride'); }}
                                                />}
                                                id={idNamingConversion('Batch OverRide', 'stockTransferLine', 'Radio')}
                                                label="Batch Applicable"
                                                labelPlacement="top"
                                                checked={lineForm?.batchOverride}
                                                disabled={batch?.filter(el => !el.id)?.length || view ? true : false}
                                                className={clsx(classes.marginLeft0, classes.flexStart)}
                                            />
                                        </Col>
                                        <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                                            {/* <NavLink
                                                    to="#"
                                                    id={idNamingConversion('Add Batch', 'stockTransferLine', 'Link')}
                                                    onClick={() => addBatch(lineForm)}
                                                    className={clsx(classes.customLink, classes.textAlignRight)}>
                                                    <Image
                                                        src={AddIcon}
                                                        preview={false}
                                                        className={clsx(classes.antImage, classes.padding10Left)}
                                                    /> <span className={clsx(classes.addLink, classes.color, classes.bold)}>Add Batch</span>
                                                </NavLink> */}
                                        </Col>
                                    </Row>
                                </Col>
                                <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                    <TableContainer className={clsx(classes.tablecontain, classes.tablecontainBatch)}>
                                        <Table stickyHeader>
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell className={clsx(classes.tablealign)}>Batch ID</TableCell>
                                                    <TableCell className={clsx(classes.tablealign)}>Current Stock</TableCell>
                                                    <TableCell className={clsx(classes.tablealign)}>Shipped Quantity</TableCell>
                                                    <TableCell className={clsx(classes.tablealign)}>Received Quantity</TableCell>
                                                    <TableCell className={clsx(classes.tablealign)}>Balance Quantity</TableCell>

                                                    {
                                                        parameterDetails?.batchMfgDate && <TableCell className={clsx(classes.tablealign)}>Mfg Date</TableCell>
                                                    }
                                                    {
                                                        parameterDetails?.batchExpiryDate && <TableCell className={clsx(classes.tablealign)}>Expiry Date</TableCell>
                                                    }
                                                    {
                                                        parameterDetails?.batchBestBeforeDate && <TableCell className={clsx(classes.tablealign)}>Use By | Best Before</TableCell>
                                                    }
                                                    <TableCell className={clsx(classes.tablealign)}></TableCell>
                                                </TableRow>
                                            </TableHead>
                                            {
                                                batch?.length > 0 ? batch.map((data, i) => (
                                                    <TableRow id={'tableRow_' + i} sx={{ '&:last-child td, &:last-child th': { border: 0 } }} className={clsx(classes.positionRelative)}>
                                                        <TableCell className={clsx(classes.storeSalesLineCell)}>
                                                            {data?.batchNumber}
                                                        </TableCell>
                                                        <TableCell className={clsx(classes.storeSalesLineCell)}>
                                                            {data?.availableStock || ''}
                                                        </TableCell>
                                                        <TableCell className={clsx(classes.storeSalesLineCell)}>
                                                            {
                                                                view ? data?.toQuantity :
                                                                    <TextField autoComplete='one-time-code'
                                                                        fullWidth
                                                                        className={clsx(classes.batchTextField)}
                                                                        value={data?.toQuantity || ''}
                                                                        type={'number'}
                                                                        InputProps={{
                                                                            classes: {
                                                                                input: clsx(classes.textFieldColor, classes.storeSalesLineQuantityInput),
                                                                            }
                                                                        }}
                                                                        InputLabelProps={{
                                                                            className: classes.textAreaLableColorCustom,
                                                                        }}
                                                                        inputProps={{
                                                                            step: "any"
                                                                        }}
                                                                        id={idNamingConversion('To Qty_' + i, 'stockTransferLine', 'TextField')}
                                                                        onWheel={(e) => e.target.blur()}
                                                                        onFocus={(e) => e.target.select()}
                                                                        onChange={(e) => {
                                                                            if (e.target.value !== '') {
                                                                                if (e.target.value < 0) {
                                                                                    changeHandlerBatch(e.target.value = 0, 'toQuantity', i)
                                                                                } else {
                                                                                    changeHandlerBatch(e.target.value, 'toQuantity', i)
                                                                                }
                                                                            } else {
                                                                                changeHandlerBatch(e.target.value, 'toQuantity', i)
                                                                            }
                                                                        }}
                                                                    />
                                                            }
                                                        </TableCell>
                                                        <TableCell className={clsx(classes.storeSalesLineCell)}>
                                                            {
                                                                view ? <>
                                                                    {
                                                                        receivedView ? data?.receivedQuantity : <TextField autoComplete='one-time-code'
                                                                            fullWidth
                                                                            className={clsx(classes.batchTextField)}
                                                                            value={data?.receivedQuantity || ''}
                                                                            type={'number'}
                                                                            InputProps={{
                                                                                classes: {
                                                                                    input: clsx(classes.textFieldColor, classes.storeSalesLineQuantityInput),
                                                                                }
                                                                            }}
                                                                            InputLabelProps={{
                                                                                className: classes.textAreaLableColorCustom,
                                                                            }}
                                                                            inputProps={{
                                                                                step: "any"
                                                                            }}
                                                                            id={idNamingConversion('Received Qty_' + i, 'stockTransferLine', 'TextField')}
                                                                            onWheel={(e) => e.target.blur()}
                                                                            onFocus={(e) => e.target.select()}
                                                                            onChange={(e) => {
                                                                                if (e.target.value !== '') {
                                                                                    if (e.target.value < 0) {
                                                                                        changeHandlerBatch(e.target.value = 0, 'receivedQuantity', i)
                                                                                    } else {
                                                                                        changeHandlerBatch(e.target.value, 'receivedQuantity', i)
                                                                                    }
                                                                                } else {
                                                                                    changeHandlerBatch(e.target.value, 'receivedQuantity', i)
                                                                                }
                                                                            }}
                                                                        />
                                                                    }
                                                                </> :
                                                                    <TextField autoComplete='one-time-code'
                                                                        fullWidth
                                                                        className={clsx(classes.batchTextField)}
                                                                        value={data?.receivedQuantity || ''}
                                                                        type={'number'}
                                                                        InputProps={{
                                                                            classes: {
                                                                                input: clsx(classes.textFieldColor, classes.storeSalesLineQuantityInput),
                                                                            }
                                                                        }}
                                                                        InputLabelProps={{
                                                                            className: classes.textAreaLableColorCustom,
                                                                        }}
                                                                        inputProps={{
                                                                            step: "any"
                                                                        }}
                                                                        id={idNamingConversion('Received Qty_' + i, 'stockTransferLine', 'TextField')}
                                                                        onWheel={(e) => e.target.blur()}
                                                                        onFocus={(e) => e.target.select()}
                                                                        onChange={(e) => {
                                                                            if (e.target.value !== '') {
                                                                                if (e.target.value < 0) {
                                                                                    changeHandlerBatch(e.target.value = 0, 'receivedQuantity', i)
                                                                                } else {
                                                                                    changeHandlerBatch(e.target.value, 'receivedQuantity', i)
                                                                                }
                                                                            } else {
                                                                                changeHandlerBatch(e.target.value, 'receivedQuantity', i)
                                                                            }
                                                                        }}
                                                                    />
                                                            }
                                                        </TableCell>
                                                        <TableCell className={clsx(classes.storeSalesLineCell)}>
                                                            {parseFloat(data?.balanceQuantity || 0)}
                                                        </TableCell>
                                                        {
                                                            parameterDetails?.batchMfgDate &&
                                                            <TableCell className={clsx(classes.storeSalesLineCell)}>
                                                                {data?.manufacturingDate ? moment(data?.manufacturingDate).format('DD-MMM-YYYY') : '---'}
                                                            </TableCell>
                                                        }
                                                        {
                                                            parameterDetails?.batchExpiryDate &&
                                                            <TableCell className={clsx(classes.storeSalesLineCell)}>
                                                                {data?.expiryDate ? moment(data?.expiryDate).format('DD-MMM-YYYY') : '---'}
                                                            </TableCell>
                                                        }
                                                        {
                                                            parameterDetails?.batchBestBeforeDate &&
                                                            <TableCell className={clsx(classes.storeSalesLineCell)}>
                                                                {data?.useByDate ? moment(data?.useByDate).format('DD-MMM-YYYY') : '---'}
                                                            </TableCell>
                                                        }
                                                        <TableCell style={{ padding: "5px 0 5px 5px" }} className={clsx(classes.storeSalesLineCell, classes.textAlignCenter)}>
                                                            {
                                                                view ? '' : <NavLink id={idNamingConversion('Delete_' + data.id, 'stockTransferLine', 'Icon')} to={"#"} onClick={() => onDeletBatch(data)}>
                                                                    <Image
                                                                        src={DeleteIcon}
                                                                        preview={false}
                                                                    />
                                                                </NavLink>
                                                            }
                                                        </TableCell>
                                                    </TableRow>
                                                )) : <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                    <TableCell className={classes.textAlignCenter} colSpan={5}>
                                                        <p className={clsx(classes.noResultsText, classes.textAlignCenter)}>{'No Batch Details here'}</p>
                                                    </TableCell>
                                                </TableRow>
                                            }
                                            {
                                                lineError?.batchQuantity && <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }} className={clsx(classes.positionRelative)}>
                                                    <TableCell className={classes.textAlignLeft} colSpan={5}><p style={{ color: "red" }}>{lineError?.batchQuantity}</p></TableCell>
                                                </TableRow>
                                            }
                                        </Table>
                                    </TableContainer>
                                </Col>
                            </Row>
                        </Col> : null
                    }
                </Row>
            </div>
            <div className={clsx(classes.btnParent)}>
                <Space direction="horizontal" align="center" size={[10, 10]}>
                    {
                        !headerView ? <>
                            {
                                view ? <NavLink to={'#'} className={clsx(classes.modalBtn)} onClick={() => handleEdit(false)}>Edit</NavLink> :
                                    <>
                                        <Button
                                            key="save"
                                            color="primary"
                                            variant="contained"
                                            type={'submit'}
                                            id={idNamingConversion('Save', 'stockTransferLine', 'TextField')}
                                            className={clsx(classes.modalBtn)}>
                                            {
                                                title === 'Edit' ? 'Update & Close' : 'Save & Close'
                                            }
                                        </Button>
                                        {
                                            title === 'Add' && <Button
                                                key="add"
                                                color='primary'
                                                variant="contained"
                                                id={idNamingConversion('Add More', 'stockTransferLine', 'TextField')}
                                                className={clsx(classes.AddMoreBtn)}
                                                onClick={(e) => handleAddMore(e)}
                                            >Add More</Button>
                                        }
                                    </>
                            }
                        </> : receivedView ? '' : <Button
                            key="save"
                            color="primary"
                            variant="contained"
                            type={'submit'}
                            id={idNamingConversion('Save', 'stockTransferLine', 'TextField')}
                            className={clsx(classes.modalBtn)}>
                            Update & Close
                        </Button>
                    }
                </Space>
            </div>
        </Box>
    )
}